import Model from 'models/Model';
import Dealer from '../../dealerManagement/dealer/Model.Dealer';
import Client from '../client/Model.Client';
import Payee from '../payee/Model.Payee';
import PayeeType from '../payeeType/Model.PayeeType';

export default class ClaimJobItemPayee
  extends Model<Model.IClaimJobItemPayee>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimJobItemPayee>
{
  id: number;
  payeeTypeId?: number;
  payeeType?: PayeeType;
  payeeId?: number;
  payee?: Payee;
  dealerId?: number;
  dealer?: Dealer;
  clientId?: number;
  client?: Client & {
    paymentMethodCode?: string;
  };

  get typeAndId(): string {
    return this.dealerId
      ? `${PayeeType.DEALER_ID}:${this.dealerId}`
      : this.clientId
        ? `${PayeeType.CLIENT_ID}:${this.clientId}`
        : this.payeeId
          ? `${this?.payeeTypeId || this?.payeeType?.id}:${this.payeeId}`
          : null;
  }
  constructor(
    data: Partial<Model.IClaimJobItemPayee> | Utils.FormData<Model.IClaimJobItemPayee>,
    language?: Locale.Languages
  ) {
    super({ payeeType: PayeeType, payee: Payee, dealer: Dealer, client: Client }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    const payee = this.dealer ?? this.client ?? this.payee;
    return {
      id: this.id ?? payee?.displayInfo?.id,
      title: payee?.id
        ? `${payee.displayInfo?.title} (${payee.displayInfo?.id})`
        : this.id
          ? this.id?.toString()
          : undefined,
      subtitle: payee?.fullAddress,
      info: this.payeeType?.name,
    };
  }

  getEmailForPayment({ clientOverrideEmail }: { clientOverrideEmail?: string } = {}): string | undefined {
    if (this.payeeTypeId === PayeeType.DEALER_ID) {
      return this.dealer?.claimPaymentEmail;
    }

    if (this.payeeTypeId === PayeeType.CLIENT_ID) {
      return clientOverrideEmail ?? this.client?.email;
    }

    return this.payee?.email;
  }

  get fullAddress(): string | undefined {
    return this.dealer?.fullAddress ?? this.client?.fullAddress ?? this.payee?.fullAddress;
  }

  get addressDetails(): Model.AddressDetails {
    const payeeObject = this.dealer ?? this.client ?? this.payee;

    if (!payeeObject) {
      return null;
    }

    return {
      city: payeeObject.city,
      province: payeeObject.provinceCode,
      postalCode: payeeObject.postalCode,
      countryCode: payeeObject.countryCode,
    };
  }
}
